import { nanoid } from "@reduxjs/toolkit";
import shoes1 from "../../../assets/women/walking/shoes1.png";
import shoes11 from "../../../assets/women/walking/shoes11.png";
import shoes12 from "../../../assets/women/walking/shoes12.png";
import shoes13 from "../../../assets/women/walking/shoes13.png";

import shoes2 from "../../../assets/women/walking/shoes2.png";
import shoes21 from "../../../assets/women/walking/shoes21.png";
import shoes22 from "../../../assets/women/walking/shoes22.png";
import shoes23 from "../../../assets/women/walking/shoes23.png";

import shoes3 from "../../../assets/women/walking/shoes3.png";
import shoes31 from "../../../assets/women/walking/shoes31.png";
import shoes32 from "../../../assets/women/walking/shoes32.png";
import shoes33 from "../../../assets/women/walking/shoes33.png";

import shoes4 from "../../../assets/women/walking/shoes4.png";
import shoes41 from "../../../assets/women/walking/shoes41.png";
import shoes42 from "../../../assets/women/walking/shoes42.png";
import shoes43 from "../../../assets/women/walking/shoes43.png";

import shoes5 from "../../../assets/women/walking/shoes5.png";
import shoes51 from "../../../assets/women/walking/shoes51.png";
import shoes52 from "../../../assets/women/walking/shoes52.png";
import shoes53 from "../../../assets/women/walking/shoes53.png";

import shoes6 from "../../../assets/women/walking/shoes6.png";
import shoes61 from "../../../assets/women/walking/shoes61.png";
import shoes62 from "../../../assets/women/walking/shoes62.png";
import shoes63 from "../../../assets/women/walking/shoes63.png";

export const WalkingWomenData = [
  {
    id: nanoid(),
    image: shoes1,
    title: "SOFTRIDE Enzo Evo Unisex Running Shoes",
    price: 6999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Frosty Pink",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "A perfect pairing for the perfect pair – our SOFTRIDE and Enzo franchises combine in this high-energy SOFTRIDE Enzo Evo Unisex Running Shoes. The technical cushioning in the footbed and sockliner optimises your comfort as you run, while the bold branding, jewel piece, and TPU caging offer a fresh vibe",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Clamshell construction",
      },
      {
        id: nanoid(),
        point: "Moulded fine TPU cage",
      },
      {
        id: nanoid(),
        point: "Jewel piece in the midsole",
      },
      {
        id: nanoid(),
        point: "Webbing detail for lockdown fit",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo on the tongue, lateral toe, and jewel piece",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark on the heel",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "ADIANA Viet Nam Footwear Company",
      },

      {
        id: nanoid(),
        point:
          "FVNAD Thanh Hoa Province Ha Lung Thuong Hamlet Tho Dan Commune Trieu Son Dictrict 41517 Thanh Hoa",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes1,
      },
      {
        id: nanoid(),
        imgCard: shoes11,
      },
      {
        id: nanoid(),
        imgCard: shoes12,
      },
      {
        id: nanoid(),
        imgCard: shoes13,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes2,
    title: "SOFTRIDE Enzo Evo Unisex Running Shoes",
    price: 6999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Rosebay-Rose Quartz-PUMA White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "A perfect pairing for the perfect pair – our SOFTRIDE and Enzo franchises combine in this high-energy SOFTRIDE Enzo Evo Unisex Running Shoes. The technical cushioning in the footbed and sockliner optimises your comfort as you run, while the bold branding, jewel piece, and TPU caging offer a fresh vibe.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Clamshell construction",
      },
      {
        id: nanoid(),
        point: "Moulded fine TPU cage",
      },
      {
        id: nanoid(),
        point: "Jewel piece in the midsole",
      },
      {
        id: nanoid(),
        point: "Webbing detail for lockdown fit",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo on the tongue, lateral toe, and jewel piece",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark on the heel",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "ADIANA Viet Nam Footwear Company",
      },

      {
        id: nanoid(),
        point:
          "FVNAD Thanh Hoa Province Ha Lung Thuong Hamlet Tho Dan Commune Trieu Son Dictrict 41517 Thanh Hoa",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes2,
      },
      {
        id: nanoid(),
        imgCard: shoes21,
      },
      {
        id: nanoid(),
        imgCard: shoes22,
      },
      {
        id: nanoid(),
        imgCard: shoes23,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes3,
    title: "SOFTRIDE Sophia Women's Walking Shoes",
    price: 4249,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Ignite Pink-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Modern style meets streetwear fashion in the INTERFLEX Modern sneaker. These runners feature a bold contemporary design with",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Modern style meets streetwear fashion in the INTERFLEX Modern sneaker. These runners feature a bold contemporary design with an exaggerated tongue and contrast EVA foam midsole for a striking appearance. Ground-contact EVA at the outsole adds a lightweight feel and excellent cushioning, keeping these runners comfortable, no matter where your day takes you.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 8 mm",
      },
      {
        id: nanoid(),
        point: " Comfortable style by PUMA",
      },
      {
        id: nanoid(),
        point: "PUMA branding details",
      },
      {
        id: nanoid(),
        point: "Signature PUMA design elements",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONETAO XUYEN WARD CHATHAM ROAD SOUTH, THANH HOA CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes31,
      },
      {
        id: nanoid(),
        imgCard: shoes32,
      },
      {
        id: nanoid(),
        imgCard: shoes33,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes4,
    title: "SOFTRIDE Sophia Women's Walking Shoes",
    price: 4249,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Ignite Pink-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "We're excited to introduce you to the Softride Sophia, designed for those who love to make a fashion statement without sacrificing",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "We're excited to introduce you to the Softride Sophia, designed for those who love to make a fashion statement without sacrificing comfort when they train. The Softride midsole and SoftFoam+ footbed will keep you light on your feet, and the zoned rubber outsole ensures traction as you hit those light training moves. Stacked mini-platform style tooling and a bootie style upper with bold PUMA branding keeps you at the forefront of cutting-edge style.",
    detail: [
      {
        id: nanoid(),
        point: "Low boot silhouette",
      },
      {
        id: nanoid(),
        point: "Bootie style upper with synthetic cage lacing system",
      },
      {
        id: nanoid(),
        point: "SoftFoam+ sockliner",
      },
      {
        id: nanoid(),
        point: "Softride midsole for extreme cushioning an all-day comfort",
      },
      {
        id: nanoid(),
        point:
          "Outsole with zoned rubber pods at heel and toe for added traction",
      },
      {
        id: nanoid(),
        point: "Lace closure for a snug fit",
      },
      {
        id: nanoid(),
        point:
          "Stacked and sculpted platform style tooling with paintable top line",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo on quarter panel",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark on tongue webbing",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SAO VIET CORPORATION",
      },

      {
        id: nanoid(),
        point:
          "VN BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL ZONE, THUAN AN CITY, BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes4,
      },
      {
        id: nanoid(),
        imgCard: shoes41,
      },
      {
        id: nanoid(),
        imgCard: shoes42,
      },
      {
        id: nanoid(),
        imgCard: shoes43,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes5,
    title: "SOFTRIDE Sophia Women's Walking Shoes",
    price: 3749,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Rose Gold",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Platform",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 10 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point:
          "Bootie construction on upper with distinct and unique synthetic cage lacing system",
      },
      {
        id: nanoid(),
        point:
          "Tooling stacked at mini-platform level, giving a true femme fashion point of view",
      },
      {
        id: nanoid(),
        point: "SoftFoam+ sockliner for optimal step-in comfort",
      },
      {
        id: nanoid(),
        point:
          "Outsole with zoned rubber outsole pods designed for light training movements",
      },
      {
        id: nanoid(),
        point: "Bold PUMA Cat Logo on rear lateral side",
      },
      {
        id: nanoid(),
        point: "Label with PUMA Wordmark on tongue",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SAO VIET CORPORATION LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNSJ BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL ZONE, THUAN AN CITY, BINH DUONG PROVINCE THUAN AN CITY ",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes5,
      },
      {
        id: nanoid(),
        imgCard: shoes51,
      },
      {
        id: nanoid(),
        imgCard: shoes52,
      },
      {
        id: nanoid(),
        imgCard: shoes53,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes6,
    title: "SOFTRIDE Enzo Evo Unisex Running Shoes",
    price: 5599,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-CASTLEROCK",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Introducing a Walking shoe that brings together two of PUMA's most popular franchises: SOFTRIDE and Enzo. Making the most of the SOFTRIDE EVA technology, these shoes provide extreme cushioning as well as all-day comfort. So whether you're at the gym or just strolling around town, these shoes have got you covered. Style-wise they showcase a highly progressive upper design language, highlighted by bold branding. All in all, this is a shoe designed to help you truly stand out from the crowd.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Progressive upper design",
      },
      {
        id: nanoid(),
        point: "Moulded synthetic midfoot cage",
      },
      {
        id: nanoid(),
        point: "TPU eyestay",
      },
      {
        id: nanoid(),
        point:
          "SOFTRIDE EVA technology for extreme cushioning and all-day comfort",
      },
      {
        id: nanoid(),
        point: "Bold PUMA Cat Logo on the upper and tongue",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmil Running",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "PONTUS FOOTWEAR LTD Footwear Company",
      },

      {
        id: nanoid(),
        point:
          "FKHPT TAKAO PROVINCENATIONAL RD. #3 KHLA KRAHOEM VILLAGE, TAPHEM COMMUNE 210213 TRAMKAK DISTRICT",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes6,
      },
      {
        id: nanoid(),
        imgCard: shoes61,
      },
      {
        id: nanoid(),
        imgCard: shoes62,
      },
      {
        id: nanoid(),
        imgCard: shoes63,
      },
    ],
  },
];
